
import { supabase } from "@/integrations/supabase/client";

interface MailchimpSubscribeParams {
  email: string;
  firstName?: string;
  lastName?: string;
  tags?: string[];
  status: 'NonSubscribed' | 'Subscribed';
}

interface MailchimpResponse {
  success: boolean;
  error?: string;
  data?: any;
}

export const subscribeToMailchimp = async ({
  email,
  firstName,
  lastName,
  tags = [],
  status,
}: MailchimpSubscribeParams): Promise<MailchimpResponse> => {
  try {
    console.log('Sending request to mailchimp-subscribe function with data:', { email, firstName, lastName, tags, status });
    
    const { data, error } = await supabase.functions.invoke('mailchimp-subscribe', {
      body: {
        email,
        firstName,
        lastName,
        tags,
        status,
      },
    });

    if (error) {
      console.error('Error calling mailchimp-subscribe function:', error);
      return { success: false, error: error.message };
    }

    console.log('Received response from mailchimp-subscribe function:', data);
    return data;
  } catch (error) {
    console.error('Error in subscribeToMailchimp:', error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};
